// extracted by mini-css-extract-plugin
module.exports = {"topWrapper":"FRg5","logoLink":"FRzh","logoImg":"FRzj","bottomWrapper":"FRhb"};